/**
 * Read More JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class ReadMore
 */
class ReadMore {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        this.readMoreBtn = $( '.read-more-button' );
        this.transparentContent = $( '.transparent-content' );
        this.readMoreContent = $( '.read-more' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        $( this.readMoreBtn ).on( 'click', () => {
            this.showAllContent();

            // Move focus to content which is to be revaled, to keep
            // screen readers read the content in logical order
            this.readMoreContent.attr( 'tabindex', '-1' );
            this.readMoreContent.focus();
        });
    }

    /**
     * This method initializes dynamic accessibility for the read more content.
     * If somehow JS isn't able to load, the content is still visible.
     */
    a11y() {
        this.transparentContent.removeClass( 'js-hidden' );
        this.readMoreBtn.removeClass( 'js-hidden' );
        this.readMoreContent.addClass( 'js-hidden' );
    }

    /**
     * This handles the visibility and aria classes of the read more button and the read more content.
     *
     */
    showAllContent() {

        // Show hidden text.
        this.readMoreContent.removeClass( 'js-hidden' );

        // Hide button.
        this.readMoreBtn.addClass( 'js-hidden' );

        // Hide the overlay.
        this.transparentContent.addClass( 'js-hidden' );

        // Change the aria states.
        this.readMoreBtn.attr( 'aria-expanded', 'true' );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.a11y();
        this.events();
    }
}

// Export the class reference.
module.exports = ReadMore;



// WEBPACK FOOTER //
// ./assets/scripts/read-more.js